import SpaceFillingCurve from "./spaceFillingCurve";
export default class ZOrderCurve extends SpaceFillingCurve {
    encode(vertex) {
        this.validateCoordinates(vertex);
        const shiftedX = vertex.x + this._coordinateShift;
        const shiftedY = vertex.y + this._coordinateShift;
        let mortonCode = 0;
        for (let i = 0; i < this._numBits; i++) {
            mortonCode |= ((shiftedX & (1 << i)) << i) | ((shiftedY & (1 << i)) << (i + 1));
        }
        return mortonCode;
    }
    decode(mortonCode) {
        const x = this.decodeMorton(mortonCode) - this._coordinateShift;
        const y = this.decodeMorton(mortonCode >> 1) - this._coordinateShift;
        return { x, y };
    }
    decodeMorton(code) {
        let coordinate = 0;
        for (let i = 0; i < this._numBits; i++) {
            coordinate |= (code & (1 << (2 * i))) >> i;
        }
        return coordinate;
    }
    static decode(mortonCode, numBits, coordinateShift) {
        const x = ZOrderCurve.decodeMorton(mortonCode, numBits) - coordinateShift;
        const y = ZOrderCurve.decodeMorton(mortonCode >> 1, numBits) - coordinateShift;
        return { x, y };
    }
    static decodeMorton(code, numBits) {
        let coordinate = 0;
        for (let i = 0; i < numBits; i++) {
            coordinate |= (code & (1 << (2 * i))) >> i;
        }
        return coordinate;
    }
}
//# sourceMappingURL=zOrderCurve.js.map